import {Component, OnInit} from "@angular/core";
import {Location} from "@angular/common";
import {AuthenticationService} from "./authentication.service";
import {Permission} from "./api/permissions/api.models";

@Component({
    selector : 'menu',
    template: require('./menu.component.html'),
    styles: [require('./menu.component.scss')]
})

export class MenuComponent implements OnInit {
    menu: any[] = [];
    sections: any[] = [
        {
            id        : 'messages',
            label     : 'Messages',
            link      : '/messages',
            icon      : 'envelope',
            collapsed : this.route.path(false).match(/^\/(settings|home)/) === null,
            children  : [
                {
                    id : 'overview',
                    label : 'Overview',
                    link : '/messages/overview',
                    icon : 'globe',
                    canDo : [
                        Permission.MESSAGES_SHOW_OVERVIEW
                    ]
                },
                {
                    id : 'add',
                    label : 'Add',
                    link : '/messages/add',
                    icon : 'plus',
                    canDo : [
                        Permission.MESSAGES_WRITE_NEW_MESSAGES
                    ]
                },
                {
                    id : 'import',
                    label : 'Import',
                    link : '/messages/import',
                    icon: 'download',
                    canDo : [
                        Permission.MESSAGES_IMPORT_POKES
                    ]
                },
                {
                    id : 'check',
                    label : 'Check',
                    link : '/messages/check',
                    icon : 'check-square',
                    canDo : [
                        Permission.MESSAGES_CHECK_MESSAGES
                    ]
                }
            ]
        },
        {
            id        : 'schemas',
            label     : 'Schema\'s',
            link      : '/schemas',
            icon      : 'calendar',
            collapsed : this.route.path(false).match(/^\/schemas/) === null,
            children  : [
                {
                    id : 'overview',
                    label : 'Overview',
                    link : '/schemas/overview',
                    icon : 'globe',
                    canDo : [
                        Permission.SCHEMAS_SHOW_OVERVIEW
                    ]
                }
            ]
        },
        {
            id : 'Statistics',
            label : 'Statistics',
            link : '/statistics',
            icon : 'chart-pie',
            children: [
                {
                    id: 'messages',
                    label : 'User statistics',
                    link : '/statistics/users',
                    icon : 'user',
                    canDo : [
                        Permission.STATISTICS_MESSAGES
                    ]
                },
                {
                    id: 'user-performance',
                    label : 'User performance',
                    link : '/statistics/user-performance',
                    icon : 'envelope',
                    canDo : [
                        Permission.STATISTICS_USER_PERFORMANCE
                    ]
                },
                {
                    id: 'messageStatistics',
                    label : 'Message performance',
                    link : '/statistics/messages',
                    icon : 'comments',
                    canDo : [
                        Permission.MESSAGES_STATISTICS_READ
                    ]
                },
            ]
        },
        {
            id : 'Insights',
            label : 'Insights',
            link : '/insights',
            icon : 'eye',
            children: [
                {
                    id: 'profiles-per-geo',
                    label : 'Profiles per geo',
                    link : '/insights/profiles-per-geo',
                    icon : 'globe',
                    canDo : [
                        Permission.INSIGHTS_PROFILES_PER_GEO
                    ]
                },
                {
                    id: 'profiles-per-ip',
                    label : 'Profiles per ip-level',
                    link : '/insights/profiles-per-ip-level',
                    icon : 'mobile-alt',
                    canDo : [
                        Permission.INSIGHTS_PROFILES_PER_IP_LEVEL
                    ]
                }
            ]
        },
        {
            id : 'Settings',
            label : 'Settings',
            link : '/settings',
            icon : 'wrench',
            collapsed : this.route.path(false).match(/^\/(settings)/) === null,
            children : [
                {
                    id : 'users',
                    label : 'Users',
                    link : '/settings/users',
                    icon : 'users',
                    canDo : [
                        Permission.USERS_WRITE_ALL,
                        Permission.USERS_WRITE
                    ]
                },
                {
                    id : 'companies',
                    label : 'Companies',
                    link : '/settings/companies',
                    icon : 'building',
                    canDo : [
                        Permission.COMPANIES_WRITE
                    ]
                },
                {
                    id : 'roles',
                    label : 'Roles',
                    link : '/settings/roles',
                    icon : 'address-card',
                    canDo : [
                        Permission.ROLES_WRITE
                    ]
                },
                {
                    id : 'languages',
                    label : 'Languages',
                    link : '/settings/languages',
                    icon : 'flag',
                    canDo : [
                        Permission.LANGUAGES_WRITE
                    ]
                },
                {
                    id: 'messagecentrals',
                    label: 'Messagecentrals',
                    link: '/settings/messagecentrals',
                    icon: 'comment',
                    canDo: [
                        Permission.MESSAGECENTRAL_WRITE
                    ]
                },
                {
                    id: 'bases',
                    label: 'Base (geo)',
                    link: '/settings/bases',
                    icon: 'cogs',
                    canDo: [
                        Permission.BASES_WRITE
                    ]
                }
            ]
        }
    ];

    constructor(private route: Location, private auth: AuthenticationService) {}

    ngOnInit() {
        let openFirstSection: boolean = this.route.path(false).match(/^\/home$/) !== null;

        this.menu = [];
        this.sections.forEach((section: any) => {
            let newSection       = Object.assign({}, section);
            newSection.children  = [];

            if (openFirstSection === false) {
                newSection.collapsed = this.route.path(false).match(new RegExp('^\\' + newSection.link)) === null
            } else {
                newSection.collapsed = false;
                openFirstSection     = false;
            }

            if (!section.children.length) {
                this.menu.push(newSection);
                return;
            }

            section.children.forEach((child: any) => {
                if (!child.canDo || this.auth.canDoAny(child.canDo) === true) {
                    newSection.children.push(child);
                    return;
                }
            });

            if (newSection.children.length) {
                this.menu.push(newSection);
            }
        });
    }

    openMenu($event, index) {
        $event.preventDefault();

        let clickedOnExpanded = this.menu[index].collapsed === false;

        this.menu.forEach(function(item) {
            item.collapsed = true;
        });

        if (clickedOnExpanded === false) {
            this.menu[index].collapsed = false;
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/menu.component.ts